import React, { Component } from "react";
import { Result, Spin, Button } from "antd";
import LayoutPage from "../LayoutIdentificationPages";
import ResetPasswordForm from "./ResetPasswordForm";
import { checkValidity as checkValidityRequestApi } from "../../api/Password";

class ResetPassword extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      signature: null,
      data: null,
      event: null,
      email: null,
    };

    this.goToLoginPage = this.goToLoginPage.bind(this);
    this.redirectToRequest = this.redirectToRequest.bind(this);
    this.removeUrlParams = this.removeUrlParams.bind(this);
  }

  urlSigned() {
    const location = this.props.location;
    const hasData = new URLSearchParams(location.search).has("data");
    const hasSignature = new URLSearchParams(location.search).has("signature");

    return hasData && hasSignature;
  }

  getParams(key) {
    let buff = new Buffer(key, 'base64');
    let text = buff.toString('ascii');

    return JSON.parse(text);
  }

  componentDidMount() {
    if (!this.urlSigned()) {
      return;
    }

    const location = this.props.location;
    const data = new URLSearchParams(location.search).get("data");
    const signature = new URLSearchParams(location.search).get("signature");

    let { event, email } = this.getParams(data);

    this.setState({
      signature,
      data,
      event: (event) ? event : null,
      email: (email) ? email : null,
    }, () => this.checkValidity());
  }

  async checkValidity() {
    const { data, signature } = this.state;

    checkValidityRequestApi(data, signature)
      .then(data => {
        this.setState({ loading: false });

        if (!!data.msg) {
          throw new Error(data.msg);
        }
      })
      .catch(error => {
        if (error.message === "Expired signature") {
          this.redirectToRequest();
          return;
        }

        this.removeUrlParams();
      });
  }

  redirectToRequest() {
    this.props.history.push({
      pathname: "/password/request",
      state: {
        redirect: true,
        expiredLink: true
      }
    });
  }

  removeUrlParams() {
    const url = this.props.location.pathname;
    this.props.history.push(url);
  }

  goToLoginPage() {
    this.props.history.push('/login');
  }

  render() {
    if (!this.urlSigned()) {
      return (
        <div style={{ marginTop: "5rem" }}>
          <Result
            status="404"
            title="Oops..."
            subTitle="Désolé, la page que vous cherchez semble introuvable."
            extra={
              <Button type="primary" onClick={this.goToLoginPage}>Page d'accueil</Button>
            }
          />
        </div>
      );
    }

    const { loading, email, event, data, signature } = this.state;
    let title = "Changement du mot de passe";
    if (event === "new_user") {
      title = "Définisez votre mot de passe";
    }

    return (
      <LayoutPage title={title}>
        <Spin spinning={loading} tip="Chargement...">
          <ResetPasswordForm
            email={email}
            data={data}
            signature={signature}
            onExpiredToken={this.redirectToRequest}
            onError={this.removeUrlParams}
          />
        </Spin>
      </LayoutPage>
    );
  }
}

export default ResetPassword;
